import React from "react";
import Layout from "./Layout";
import { Shop } from "components/common/Card";
import helper from "utils/helper";
import Pagination from "components/common/Pagination";

const ShopSection: React.FC<{
  pagination: any;
  title: string;
  description: string;
  onShopClick?: (item: any) => void;
}> = ({ pagination, title, description, onShopClick }) => {
  return (
    <Layout iconName="sun-fog" title={title} description={description}>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4 px-6 justify-items-center">
        {pagination?.items?.map((item: any, idx: number) => (
          <Shop
            key={idx}
            {...helper.formatShop(item)}
            onClick={() => onShopClick?.(item)}
          />
        ))}
      </div>
      <div className="flex justify-center mt-3">
        <Pagination pagination={pagination} />
      </div>
    </Layout>
  );
};

export default ShopSection;
